import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Welcome from './pages/Welcome';
import POSDashboard from './pages/posdashboard';
import Products from './pages/Products';
import ProductEdit from './pages/ProductEdit';
import POS from './pages/POS';
import Orders from './pages/Orders';
import HoldBills from './pages/HoldBills';
import Login from './pages/Login';
import Layout from './components/Layout';
import { UserProvider } from './contexts/UserContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import CategorySettings from './pages/setting/categories/CategorySettings';
import UnitSettings from './pages/setting/units/UnitSettings';
import TaxSettings from './pages/setting/taxes/TaxSettings';
import BrandSettings from './pages/setting/brands/BrandSettings';
import BulkUpdate from './pages/BulkUpdate';
import Sale from './pages/accounts/Sale';
import Purchase from './pages/accounts/Purchase';
import PrintInvoice from './pages/accounts/PrintInvoice';
import ProfitLoss from './pages/accounts/ProfitLoss';
import Reports from './pages/accounts/Reports';
import Expenses from './pages/accounts/Expenses';
import Ledger from './pages/accounts/Ledger';
import ProformaInvoices from './pages/accounts/ProformaInvoices';
import InvoicesDashboard from './pages/accounts/InvoicesDashboard';
import OnlineOverview from './pages/accounts/OnlineOverview';

// optional: bootstrap JS if you need components that require JS
// import 'bootstrap/dist/js/bootstrap.bundle.min';

const Invoices = React.lazy(() => import('./pages/accounts/Invoices.jsx'));

function App() {
  return (
    <ThemeProvider theme={theme}>
    <BrowserRouter>
      <UserProvider>
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/print-invoice/:id' element={<PrintInvoice />} />
          <Route path='/*' element={
            <Layout>
              <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                  <Route path='/' element={<Welcome />} />
                  <Route path='/dashboard' element={<POSDashboard />} />
                  <Route path='/products' element={<Products />} />
                  <Route path='/products/new' element={<ProductEdit />} />
                  <Route path='/products/edit/:id' element={<ProductEdit />} />
                  <Route path='/products/bulk-update' element={<BulkUpdate />} />
                  <Route path='/pos' element={<POS />} />
                  <Route path='/hold-bills' element={<HoldBills />} />
                  <Route path='/orders' element={<Orders />} />
                  <Route path='/stock' element={<Products />} />
                  <Route path='/accounts/sale' element={<Sale />} />
                  <Route path='/accounts/purchase' element={<Purchase />} />
                  <Route path='/accounts/profit-loss' element={<ProfitLoss />} />
                  <Route path='/accounts/reports' element={<Reports />} />
                  <Route path='/accounts/invoices' element={<Invoices />} />
                  <Route path='/accounts/invoices-dashboard' element={<InvoicesDashboard />} />
                  <Route path='/accounts/online-overview' element={<OnlineOverview />} />
                  <Route path='/accounts/expenses' element={<Expenses />} />
                  <Route path='/accounts/ledger' element={<Ledger />} />
                  <Route path='/accounts/proforma-invoices' element={<ProformaInvoices />} />
                  <Route path='/accounts/invoice/:id' element={
                    <React.Suspense fallback={<div>Loading...</div>}>
                      {React.createElement(require('./pages/accounts/InvoiceView.jsx').default)}
                    </React.Suspense>
                  } />
                  <Route path='/settings/categories' element={<CategorySettings />} />
                  <Route path='/settings/units' element={<UnitSettings />} />
                  <Route path='/settings/taxes' element={<TaxSettings />} />
                  <Route path='/settings/brands' element={<BrandSettings />} />
                </Routes>
              </Suspense>
            </Layout>
          } />
        </Routes>
      </UserProvider>
    </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;